module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("The Neighbour at Number 18 – Stand by Me")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#synopsis"
    }
  }, [_vm._v("Synopsis")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#chapter-1-the-family-friend"
    }
  }, [_vm._v("Chapter 1: The Family Friend")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#chapter-2-emilias-cousin-tyler-staples"
    }
  }, [_vm._v("Chapter 2: Emilia’s Cousin Tyler Staples")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#chapter-3-emilia-is-advised",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 3: Emilia is Advised")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#chapter-4-amandas-warning",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Amanda’s Warning")])]), _c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#chapter-5-maria-anderson-marries-ronald-mackintosh",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Maria Anderson Marries Ronald Mackintosh")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#chapter-6-tyler-dies",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Tyler Dies")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#chapter-7-safari-in-south-africa",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Safari in South Africa")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#chapter-8-the-house-next-door",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: The House Next Door")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch013#chapter-9-betrayal",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: Betrayal")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch014#chapter-10-a-broken-man",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: A Broken Man")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch015#chapter-11-mimi-goes-missing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Mimi Goes Missing")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch016#chapter-12-brenda-passes-away",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Brenda Passes Away")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch017#chapter-13-a-message-from-emilia",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: A Message From Emilia")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch018#chapter-14-maureen-found",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: Maureen Found")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch019#chapter-15-tammy-goes-on-a-holiday",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: Tammy Goes on a Holiday")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch020#chapter-16-the-farm-must-go",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: The Farm Must Go")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch021#chapter-17-jonathan-comes-home",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: Jonathan Comes Home")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch022#chapter-18-maria-gets-a-stroke",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: Maria Gets a Stroke")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch023#chapter-19-maria-is-diagnosed",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: Maria is Diagnosed")])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch024#chapter-20-jonathan-takes-over",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20 Jonathan Takes Over")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-206d183d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0